<h2 mat-dialog-title>{{ "DIAGNOSTIC.MODAL.TITLE" | translate }}</h2>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content class="diagnostic-bundle-modal__content">
    <p class="diagnostic-bundle-modal__intro">
      {{ "DIAGNOSTIC.MODAL.INTRO" | translate }}
    </p>

    <p class="diagnostic-bundle-modal__active-profile">
      {{ "DIAGNOSTIC.MODAL.ACTIVE_PROFILE_LABEL" | translate }}:
      <strong>{{
        "DIAGNOSTIC.PROFILE_MENU.PROFILE." + activeProfile.name | translate
      }}</strong>
    </p>

    <mat-form-field appearance="outline" class="diagnostic-bundle-modal__field">
      <mat-label>{{ "DIAGNOSTIC.MODAL.PROBLEM_LABEL" | translate }}</mat-label>
      <textarea matInput formControlName="problem" rows="3" required></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="diagnostic-bundle-modal__field">
      <mat-label>{{ "DIAGNOSTIC.MODAL.EXPECTED_LABEL" | translate }}</mat-label>
      <textarea
        matInput
        formControlName="expected"
        rows="3"
        required
      ></textarea>
    </mat-form-field>

    <mat-checkbox
      *ngIf="screenshot"
      [(ngModel)]="includeScreenshot"
      [ngModelOptions]="{ standalone: true }"
      class="diagnostic-bundle-modal__screenshot-opt-out"
    >
      {{ "DIAGNOSTIC.MODAL.INCLUDE_SCREENSHOT" | translate }}
    </mat-checkbox>

    <div *ngIf="errorKey" role="alert" class="diagnostic-bundle-modal__error">
      {{ errorKey | translate }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="submitting">
      {{ "DIALOG.CANCEL" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid || submitting"
    >
      {{ "DIAGNOSTIC.MODAL.SUBMIT" | translate }}
    </button>
  </mat-dialog-actions>
</form>
